import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { UpdateJobGQL } from 'graphql.generated';
import { isNil } from 'lodash';
import { MenuItem } from 'primeng/api';
import { BehaviorSubject, Observable, filter, map, withLatestFrom } from 'rxjs';
import { DetailsHelperService } from 'src/app/services/details-helper.service';

import { FreyaNotificationsService } from 'src/app/services/freya-notifications.service';

import { DashboardStore, SelectedJob } from '../dashboardv2.store';

@Component({
  selector: 'app-engine-job',
  templateUrl: './engine-job.component.html',
  styleUrl: './engine-job.component.scss'
})
export class EngineJobComponent implements OnChanges {

  @Input() job: SelectedJob;

  job$ = new BehaviorSubject<SelectedJob | null>(null);

  actions$: Observable<MenuItem[]> = this.job$.pipe(
    withLatestFrom(this.dashboardStore.jobClosureReasons$),
    filter(([ job ]) => !isNil(job)),
    map(([ job, jobClosureReasons ]) => [
      {
        label: 'View',
        icon: 'pi pi-external-link',
        command: () => {
          this.router.navigate(['jobs/', job.id]);
        },
      },
      {
        label: 'Close',
        items: Object.keys(jobClosureReasons).map((closedReasonId) => ({
          label: jobClosureReasons[closedReasonId],
          command: () => this.closeJob(job.id, closedReasonId),
        })),
        visible: job.status === 'Open',
      },
      {
        label: 'Reopen',
        command: () => this.reopenJob(job.id),
        visible: job.status === 'Closed',
      }
    ]),
  );

  constructor(
    private detailsHelper: DetailsHelperService,
    private router: Router,
    private dashboardStore: DashboardStore,
    private updateJobGQL: UpdateJobGQL,
    private notify: FreyaNotificationsService,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if ('job' in changes && this.job) {
      this.job$.next(this.job);
    }
  }

  closeJob(jobId: string, closedReason: string) {
    this.updateJobGQL.mutate({ updateJobs: {
      jobId,
      closeJob: true,
      closedReason,
    }}).subscribe(() => {
      this.notify.success('Job closed successfully');
      this.dashboardStore.notifyJobUpdated(jobId);
    });
  }

  reopenJob(jobId: string) {
    this.updateJobGQL.mutate({ updateJobs: {
      jobId,
      closeJob: false,
    }}).subscribe(() => {
      this.notify.success('Job reopened successfully');
      this.dashboardStore.notifyJobUpdated(jobId);
    });
  }

  openJob() {
    this.detailsHelper.detailsItem.next({ type: 'job', item: { id: this.job.id} });
  }

  openCustomer() {
    this.openUser(this.job.customer.id);
  }

  openEstimator() {
    this.openUser(this.job.estimator.id);
  }

  openUser(userId: string) {
    this.detailsHelper.detailsItem.next({ type: 'users', item: { id: userId } });
  }

  navigate() {
    this.router.navigate([ '/jobs/', this.job.id ]);
  }

}
